/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "gambit": {
            "nested": {
              "api": {
                "nested": {
                  "v1": {
                    "nested": {
                      "checkdeposit": {
                        "nested": {
                          "DeclineReason": {
                            "values": {
                              "DECLINE_REASON_UNSPECIFIED": 0,
                              "DECLINE_REASON_UNEXPECTED": 1,
                              "DECLINE_REASON_OTHER_NONRETRYABLE": 95,
                              "DECLINE_REASON_OTHER_RETRYABLE": 96,
                              "DECLINE_REASON_CHECK_DEPOSIT_UNSUPPORTED_MICR_CODELINE_FORMAT": 79,
                              "DECLINE_REASON_CHECK_DEPOSIT_ALREADY_ACCEPTED": 85,
                              "DECLINE_REASON_CHECK_DEPOSIT_INVALID_BALANCE_TYPE": 86,
                              "DECLINE_REASON_CHECK_DEPOSIT_CUSTOMER_EXCEEDED_LIMITS": 87,
                              "DECLINE_REASON_CHECK_DEPOSIT_GIVEN_AMOUNT_DOES_NOT_MATCH_CHECK_AMOUNT": 88,
                              "DECLINE_REASON_CHECK_DEPOSIT_FROZEN_OR_DENYLISTED_CUSTOMER": 89,
                              "DECLINE_REASON_CHECK_DEPOSIT_NO_DUPLICATE_PENDING_SUBMISSIONS": 90,
                              "DECLINE_REASON_CHECK_DEPOSIT_PREVIOUS_NONRETRYABLE_DECLINE": 91,
                              "DECLINE_REASON_CHECK_DEPOSIT_CHECK_IMAGES_NOT_PROVIDED": 98,
                              "DECLINE_REASON_CHECK_DEPOSIT_CANT_RETRIEVE_SQUARE_UNIT_TOKEN": 100,
                              "DECLINE_REASON_CHECK_DEPOSIT_TIMEOUT_CHECK_SUBMISSION": 80,
                              "DECLINE_REASON_CHECK_DEPOSIT_TIMEOUT_DEPOSIT": 81,
                              "DECLINE_REASON_CHECK_DEPOSIT_TIMEOUT_REVIEW": 83,
                              "DECLINE_REASON_EXPERIMENT_DECLINE_INVALID_ACCOUNT_AFTER_HOLD_PERIOD": 99,
                              "DECLINE_REASON_ENSENTA_GENERIC": 4,
                              "DECLINE_REASON_ENSENTA_MISSING_TRANSACTION_ID": 3,
                              "DECLINE_REASON_ENSENTA_CERTIFICATE_INVALID": 92,
                              "DECLINE_REASON_MANUAL_REVIEW_GENERIC": 5,
                              "DECLINE_REASON_MANUAL_REVIEW_AMOUNT_MISMATCH": 6,
                              "DECLINE_REASON_MANUAL_REVIEW_MISSING_FOR_MOBILE_DEPOSIT_ONLY": 7,
                              "DECLINE_REASON_MANUAL_REVIEW_ENDORSEMENT_DOES_NOT_MEET_REQUIREMENTS": 8,
                              "DECLINE_REASON_MANUAL_REVIEW_ENDORSEMENT_MISSING": 9,
                              "DECLINE_REASON_MANUAL_REVIEW_ENDORSEMENT_IRREGULAR": 10,
                              "DECLINE_REASON_MANUAL_REVIEW_SIGNATURE_MISSING": 11,
                              "DECLINE_REASON_MANUAL_REVIEW_SIGNATURE_IRREGULAR": 12,
                              "DECLINE_REASON_MANUAL_REVIEW_NON_CASH_ITEM": 13,
                              "DECLINE_REASON_MANUAL_REVIEW_ALTERED_FICTITIOUS_ITEM": 14,
                              "DECLINE_REASON_MANUAL_REVIEW_IRD_USER_DEFINED": 15,
                              "DECLINE_REASON_MANUAL_REVIEW_STALE_DATED": 16,
                              "DECLINE_REASON_MANUAL_REVIEW_POST_DATED": 17,
                              "DECLINE_REASON_MANUAL_REVIEW_INVALID_DATE": 94,
                              "DECLINE_REASON_MANUAL_REVIEW_UNABLE_TO_PROCESS": 18,
                              "DECLINE_REASON_MANUAL_REVIEW_ITEM_EXCEEDS_DOLLAR_AMOUNT": 19,
                              "DECLINE_REASON_MANUAL_REVIEW_NOT_AUTHORIZED": 20,
                              "DECLINE_REASON_MANUAL_REVIEW_BRANCH_OR_ACCOUNT_SOLD": 21,
                              "DECLINE_REASON_MANUAL_REVIEW_REFER_TO_MAKER": 22,
                              "DECLINE_REASON_MANUAL_REVIEW_STOP_PAYMENT_SUSPECT": 23,
                              "DECLINE_REASON_MANUAL_REVIEW_POOR_IMAGE_QUALITY": 24,
                              "DECLINE_REASON_MANUAL_REVIEW_IMAGE_FAILS_SECURITY_CHECK": 25,
                              "DECLINE_REASON_MANUAL_REVIEW_CANNOT_DETERMINE_AMOUNT": 26,
                              "DECLINE_REASON_MANUAL_REVIEW_FI_PROHIBITED_ITEM": 27,
                              "DECLINE_REASON_MANUAL_REVIEW_MY_DEPOSIT_PROHIBITED_ITEM": 28,
                              "DECLINE_REASON_MANUAL_REVIEW_CLOSED_ACCOUNT": 76,
                              "DECLINE_REASON_MANUAL_REVIEW_FROZEN_ACCOUNT": 93,
                              "DECLINE_REASON_MANUAL_REVIEW_MISSING_AUTHORIZATION_CODE": 77,
                              "DECLINE_REASON_MANUAL_REVIEW_MICR_CODELINE_OCR_MISMATCH": 78,
                              "DECLINE_REASON_MANUAL_REVIEW_INSUFFICIENT_FUNDS": 97,
                              "DECLINE_REASON_AUTOMATED_RISK_REVIEW_GENERIC": 29,
                              "DECLINE_REASON_AUTOMATED_RISK_REVIEW_AMOUNT_MISMATCH": 30,
                              "DECLINE_REASON_AUTOMATED_RISK_REVIEW_ENDORSEMENT_MISSING": 31,
                              "DECLINE_REASON_AUTOMATED_RISK_REVIEW_SIGNATURE_MISSING": 32,
                              "DECLINE_REASON_AUTOMATED_RISK_REVIEW_IRD_USER_DEFINED": 33,
                              "DECLINE_REASON_AUTOMATED_RISK_REVIEW_STALE_DATED": 34,
                              "DECLINE_REASON_AUTOMATED_RISK_REVIEW_POST_DATED": 35,
                              "DECLINE_REASON_AUTOMATED_RISK_REVIEW_UNABLE_TO_PROCESS": 36,
                              "DECLINE_REASON_AUTOMATED_RISK_REVIEW_NOT_AUTHORIZED": 37,
                              "DECLINE_REASON_AUTOMATED_RISK_REVIEW_REFER_TO_MAKER": 38,
                              "DECLINE_REASON_AUTOMATED_RISK_REVIEW_POOR_IMAGE_QUALITY": 39,
                              "DECLINE_REASON_AUTOMATED_RISK_REVIEW_CANNOT_DETERMINE_AMOUNT": 40,
                              "DECLINE_REASON_AUTOMATED_RISK_REVIEW_FI_PROHIBITED_ITEM": 41,
                              "DECLINE_REASON_AUTOMATED_RISK_REVIEW_MY_DEPOSIT_PROHIBITED_ITEM": 42,
                              "DECLINE_REASON_AUTOMATED_RISK_REVIEW_ACCOUNT_VALIDATION_FAILED": 43,
                              "DECLINE_REASON_AUTOMATED_RISK_REVIEW_DUPLICATE_PRESENTMENT": 84,
                              "DECLINE_REASON_AUTOMATED_RISK_REVIEW_IDV_NAME_MISMATCH": 101,
                              "DECLINE_REASON_AUTOMATED_RISK_REVIEW_SAME_MAKER_SAME_PAYEE": 102,
                              "DECLINE_REASON_VOIDED_GENERIC": 2,
                              "DECLINE_REASON_VOIDED_INSUFFICIENT_FUNDS": 44,
                              "DECLINE_REASON_VOIDED_UNCOLLECTED_FUNDS_HOLD": 45,
                              "DECLINE_REASON_VOIDED_STOP_PAYMENT": 46,
                              "DECLINE_REASON_VOIDED_CLOSED_ACCOUNT": 47,
                              "DECLINE_REASON_VOIDED_UNABLE_TO_LOCATE_ACCOUNT": 48,
                              "DECLINE_REASON_VOIDED_FROZEN_OR_BLOCKED_ACCOUNT": 49,
                              "DECLINE_REASON_VOIDED_STALE_DATED": 50,
                              "DECLINE_REASON_VOIDED_POST_DATED": 51,
                              "DECLINE_REASON_VOIDED_ENDORSEMENT_MISSING": 52,
                              "DECLINE_REASON_VOIDED_ENDORSEMENT_IRREGULAR": 53,
                              "DECLINE_REASON_VOIDED_SIGNATURE_MISSING": 54,
                              "DECLINE_REASON_VOIDED_SIGNATURE_IRREGULAR": 55,
                              "DECLINE_REASON_VOIDED_NON_CASH_ITEM": 56,
                              "DECLINE_REASON_VOIDED_ALTERED_OR_FICTITIOUS": 57,
                              "DECLINE_REASON_VOIDED_UNABLE_TO_PROCESS": 58,
                              "DECLINE_REASON_VOIDED_EXCEEDS_STATED_MAX_VALUE": 59,
                              "DECLINE_REASON_VOIDED_NOT_AUTHORIZED": 60,
                              "DECLINE_REASON_VOIDED_BRANCH_ACCOUNT_SOLD": 61,
                              "DECLINE_REASON_VOIDED_REFER_TO_MAKER": 62,
                              "DECLINE_REASON_VOIDED_EXCEEDS_ALLOWABLE_NUMBER_OF_PRESENTMENTS": 63,
                              "DECLINE_REASON_VOIDED_UNUSABLE_IMAGE": 64,
                              "DECLINE_REASON_VOIDED_INVALID_IMAGE": 65,
                              "DECLINE_REASON_VOIDED_CANNOT_DETERMINE_AMOUNT": 66,
                              "DECLINE_REASON_VOIDED_REFER_TO_IMAGE": 67,
                              "DECLINE_REASON_VOIDED_DUPLICATE_PRESENTMENT": 68,
                              "DECLINE_REASON_VOIDED_FORGERY": 69,
                              "DECLINE_REASON_VOIDED_ACH_ADMIN_RETURN": 70,
                              "DECLINE_REASON_VOIDED_WARRANTY_BREACH": 71,
                              "DECLINE_REASON_VOIDED_RCC_WARRANTY_BREACH": 72,
                              "DECLINE_REASON_VOIDED_FORGED_AND_COUNTERFEIT_WARRANTY_BREACH": 73,
                              "DECLINE_REASON_VOIDED_RETIRED_INELIGIBLE_ROUTUNG_NUMBER": 74,
                              "DECLINE_REASON_VOIDED_UNKNOWN": 75,
                              "DECLINE_REASON_VOIDED_DEPOSIT_ADJUSTMENT": 103
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.gambit?.nested?.api?.nested?.v1?.nested?.checkdeposit?.nested?.DeclineReason) {
  $root.addJSON(jsonData);
}

/**
 * next id: 104
 *
 * SOURCE DeclineReason @ squareup/cash/gambit/api/v1/checkdeposit/decline_reason.proto at 8:1
 */
export const DeclineReason = $root.lookupEnum('squareup.cash.gambit.api.v1.checkdeposit.DeclineReason').values;